import React, { useState } from "react";
import { CheckedStates } from "../../Checkbox";
import { TableContext } from "../../hooks/useTableContext";
import { useThemeContext } from "../../theming/useThemeContext";
import { useGridColumnsClasses } from "../../utils/gridColumns";
import { getTableStyles } from "./tableStyles";
import { getTableHasCheckboxSelection, getTableHasDropdown, tableHasAction, } from "./utilsV2Table";
export function TableProvider(props) {
    const { brandedTable, client } = useThemeContext();
    const { drawer, headings, form } = props;
    const [isBulk, setIsBulk] = useState(false);
    const tableHasActions = tableHasAction(props);
    const tableHasDropdown = getTableHasDropdown(props);
    const tableHasCheckboxSelection = getTableHasCheckboxSelection(props);
    const hasActionAtEnd = tableHasActions || tableHasDropdown;
    const hasActionAtStart = tableHasCheckboxSelection;
    const gridColumnsClasses = useGridColumnsClasses({
        headings,
        drawer: !!drawer,
        hasActionAtStart,
        hasActionAtEnd,
    });
    const [width, setWidth] = useState();
    const setTableWidth = (newWidth) => setWidth(newWidth);
    const onSelectAll = (previousState) => {
        form?.onSelectAll && form?.onSelectAll(previousState);
        if (form?.bulkMode) {
            previousState !== CheckedStates.Checked
                ? setIsBulk(true)
                : setIsBulk(false);
        }
    };
    return (React.createElement(TableContext.Provider, { value: {
            setTableWidth,
            tableWidth: width,
            hasAction: hasActionAtEnd,
            gridClassName: gridColumnsClasses?.gridColumns ?? "",
            onSelectAll,
            isBulk,
            tableTheme: getTableStyles(props.theme ?? brandedTable, props?.styling, props?.childTable, client),
        } }, props?.children));
}
